import * as THREE from "three";
import { Context } from "../core/context";
import { DbLine } from "@/CadEngine";
import {
  DrawOperationMovePointBeforeParams,
  DrawOperationMovePointParams,
  IModifyOperation,
  ModifyOperateState,
} from "./IModifyOperation";

import { ULabel } from "@/ui/ULabel";
import {
  CommonColor,
  MultiLineAnnotationModifyAcceptParams,
} from "@/core/Parameters";

class MultiLineAnnotationModify implements IModifyOperation {
  private m_context: Context;
  private m_points: THREE.Vector3[] = [];
  private m_curPoint: THREE.Vector3 = new THREE.Vector3();
  public get Points() {
    return this.m_points;
  }
  private m_locationObject: THREE.Line;
  private m_TextLabel: ULabel;
  private m_scale = 1;
  private m_tempObjectGroup: THREE.Group = new THREE.Group();
  private m_acceptParams: MultiLineAnnotationModifyAcceptParams;
  private m_auxLine: THREE.Line | undefined;
  private m_tempLineObject: THREE.LineSegments | undefined;
  private m_tempBoxObject: THREE.LineSegments | undefined;
  private m_curState: string = "rightTop";
  private m_intervalLength: number = 0.1;
  private m_underwayCallback: (points: THREE.Vector3[]) => void;
  private m_isShift: Boolean = false;

  constructor(
    context: Context,
    underwayCallback: (points: THREE.Vector3[]) => void,
    acceptParams: MultiLineAnnotationModifyAcceptParams
  ) {
    this.m_context = context;
    this.m_underwayCallback = underwayCallback;

    this.m_locationObject = context.ToolsManager.CreatedLocationLine();
    this.m_TextLabel = new ULabel(
      this.m_context.ViewManager,
      this.m_context.Dom
    );
    this.m_TextLabel.Visibility = true;
    this.m_context.SceneManager.AuxModel.add(this.m_tempObjectGroup);
    this.m_scale = this.m_context.ViewManager.ScreenModelScale;
    this.m_acceptParams = acceptParams;
    this.m_auxLine = this.m_context.ToolsManager.CreatedAuxLine();
    this.createTempLineObject();
    this.createTempBoxObject();
  }

  OnMovePointBefore(params: DrawOperationMovePointBeforeParams): void {}
  OnMovePoint(point: DrawOperationMovePointParams): void {
    this.m_curPoint = point.point;
    this.m_locationObject.position.copy(this.m_curPoint);
    let TextLabelLocation = new THREE.Vector3();
    TextLabelLocation.x = this.m_curPoint.x + this.m_scale * 55;
    TextLabelLocation.y = this.m_curPoint.y - this.m_scale * 10;
    if (this.m_points.length == 0) {
      this.m_TextLabel.SetVaule(
        "请点取基线起点,长按Shift锁定正交",
        TextLabelLocation,
        new THREE.Vector3(1, 0, 0)
      );
    } else if (this.m_points.length == 1) {
      if (this.m_isShift) {
        this.m_curPoint = this.m_context.ToolsManager.GetOrthogonalityPoint(
          this.m_curPoint,
          this.m_points[this.m_points.length - 1]
        );
      }
      this.m_TextLabel.SetVaule(
        "请点取基线终点,长按Shift锁定正交",
        TextLabelLocation,
        new THREE.Vector3(1, 0, 0)
      );
      this.m_auxLine?.geometry.setFromPoints([
        this.m_points[0],
        this.m_curPoint,
      ]);
      this.m_auxLine?.computeLineDistances();
      let xAxis = new THREE.Vector3(1, 0, 0);
      let cV = this.m_curPoint.clone().sub(this.m_points[0]).normalize();
      let angle = cV.clone().angleTo(xAxis);
      if (cV.clone().cross(xAxis).z > 0) {
        angle = -angle;
      }
      this.m_curState = "rightTop";
      if (angle > Math.PI / 2) {
        this.m_curState = "leftTop";
      } else if (angle < -Math.PI / 2) {
        this.m_curState = "leftBottom";
      } else if (angle > -Math.PI / 2 && angle < 0) {
        this.m_curState = "rightBottom";
      }
      this.updateTempLineObject();
      this.updateTempBoxObject();
    }
  }
  OnDownPoint(point: DrawOperationMovePointParams): void {
    if (this.m_points.length < 2) {
      this.m_points.push(this.m_curPoint.clone());
      this.m_underwayCallback(this.m_points);
    }
  }
  onKeyDown(e: KeyboardEvent): void {
    if (e.keyCode == 16) {
      this.m_isShift = true;
    }
  }
  onKeyUp(e: KeyboardEvent): void {
    if (e.keyCode == 16) {
      this.m_isShift = false;
    }
  }

  OnZoom(camera: THREE.Camera): void {}

  Finish(operate: ModifyOperateState) {
    this.clear();
    let resultData = {
      linePoints: this.m_points,
    };
    if (operate == ModifyOperateState.complete) {
      return resultData;
    } else if (operate == ModifyOperateState.cancel) {
      return undefined;
    }
  }
  OnWheel(e: WheelEvent): void {
    this.m_scale = this.m_context.ViewManager.ScreenModelScale;
  }

  onMouseMove(e?: PointerEvent): void {}

  onMouseDown(e: PointerEvent): void {}

  onMouseUp(e: PointerEvent): void {}

  private createTempLineObject() {
    let geo = new THREE.BufferGeometry();
    let mat = new THREE.LineBasicMaterial({ color: CommonColor.White });
    this.m_tempLineObject = new THREE.LineSegments(geo, mat);
    this.m_tempLineObject.frustumCulled = false;
    this.m_tempObjectGroup.add(this.m_tempLineObject);
  }
  private updateTempLineObject() {
    let w = (this.m_acceptParams.textHeight / 1000) * 3.5;
    let h = this.m_acceptParams.textHeight / 1000 + this.m_intervalLength * 2;
    let tempLinePoints = [];
    switch (this.m_curState) {
      case "leftTop":
        w = -w;
        break;
      case "leftBottom":
        w = -w;
        h = -h;
        break;
      case "rightBottom":
        h = -h;
        break;
    }

    for (let i = 0; i < this.m_acceptParams.textLineNumber - 1; i++) {
      let points = [
        new THREE.Vector3(w, i * h, 0),
        new THREE.Vector3(0, i * h, 0),
        new THREE.Vector3(0, i * h, 0),
        new THREE.Vector3(0, (i + 1) * h, 0),
        new THREE.Vector3(0, (i + 1) * h, 0),
        new THREE.Vector3(w, (i + 1) * h, 0),
      ];
      tempLinePoints.push(...points);
    }
    this.m_tempLineObject!.geometry.setFromPoints(tempLinePoints);
    this.m_tempLineObject?.position.copy(this.m_curPoint);
  }

  private createTempBoxObject() {
    let geo = new THREE.BufferGeometry();
    let mat = new THREE.LineBasicMaterial({ color: CommonColor.White });
    this.m_tempBoxObject = new THREE.LineSegments(geo, mat);
    this.m_tempBoxObject.frustumCulled = false;
    this.m_tempObjectGroup.add(this.m_tempBoxObject);
  }

  private updateTempBoxObject() {
    let intervalLength = this.m_intervalLength;
    let boxW = (this.m_acceptParams.textHeight / 1000) * 3;
    let boxH = this.m_acceptParams.textHeight / 1000;
    let baseH =
      this.m_acceptParams.textHeight / 1000 + this.m_intervalLength * 2;
    let tempBoxPoints = [];
    let baseW = intervalLength;

    switch (this.m_curState) {
      case "leftTop":
        boxW = -boxW;
        baseW = -intervalLength;
        break;
      case "leftBottom":
        boxW = -boxW;
        baseW = -intervalLength;
        baseH = -baseH;
        boxH = -boxH;
        intervalLength = -intervalLength;
        break;
      case "rightBottom":
        baseH = -baseH;
        boxH = -boxH;
        intervalLength = -intervalLength;
        break;
    }

    for (let i = 0; i < this.m_acceptParams.textLineNumber; i++) {
      let points = [
        new THREE.Vector3(baseW, i * baseH + boxH + intervalLength, 0),
        new THREE.Vector3(baseW + boxW, i * baseH + boxH + intervalLength, 0),
        new THREE.Vector3(baseW + boxW, i * baseH + boxH + intervalLength, 0),
        new THREE.Vector3(baseW + boxW, i * baseH + intervalLength, 0),
        new THREE.Vector3(baseW + boxW, i * baseH + intervalLength, 0),
        new THREE.Vector3(baseW, i * baseH + intervalLength, 0),
        new THREE.Vector3(baseW, i * baseH + intervalLength, 0),
        new THREE.Vector3(baseW, i * baseH + boxH + intervalLength, 0),
      ];
      tempBoxPoints.push(...points);
    }
    this.m_tempBoxObject!.geometry.setFromPoints(tempBoxPoints);
    this.m_tempBoxObject?.position.copy(this.m_curPoint);
  }

  private clear() {
    this.m_context.ToolsManager.GroupClear(this.m_tempObjectGroup);
    this.m_context.ToolsManager.ObjectsClear([
      this.m_locationObject,
      this.m_auxLine!,
    ]);
    this.m_TextLabel.dispose();
  }
}

export { MultiLineAnnotationModify };
